export enum EUserTypes {
  INTERNO = "INTERNO",
  PLANTA = "PLANTA",
  PROVEEDOR = "PROVEEDOR",
  CORPORATIVO = "CORPORATIVO"
}

export enum EMemoTypeReference {
  REQUESTPAYMENT = "REQPAY",
  INVOICE = "INVOICE",
  OTHER = "OTHERS"
}

export enum EMaterialReceptionPartialStatus {
  PENDING = "PENDING",
  INPROCESS = "INPROCESS",
  REJECTED = "REJECTED",
  REBILLING = "REBILLING"
}

export enum EBillDetailTypes {
  INVOICE = "INVOICE",
  PAYMENTR = "PAYMENTREQUEST",
  PAYROLL = "PAYROLL",
  OTHERS = "OTHERS"
}